const currency = [
    { value: "KSH", label: "KSH" },
    { value: "USD", label: "USD" },
  ];
  
  export default currency;
  